import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
const _excluded = ["accountsPayableGlAccountExternalId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { Typography, Button, Autocomplete, TextField, Grid, Accordion, AccordionDetails, AccordionSummary, ToggleButtonGroup, ToggleButton, MenuItem, Select, IconButton, InputAdornment } from '@mui/material';
import { Icon, InputWithIcon,
// Note: hided until we develop full implementation of sub meter solution instead of interim
// SelectMenu,
toast, BackdropLoader, CONSTANTS, ExpandedTooltip } from '@livable/saas-react-components';
import BillFrequencyModal from './BillFrequencyModal';
import AllocationMethodModal from './AllocationMethodModal';
import VacantUnitBills from './VacantUnitBills';
import CADModal from './CADModal';
import { ListItem } from './UtilityAccordion/listItem';
import { UtilitiesAutocomplete } from './UtilitiesAutocomplete';
// NOTE: Hidden Auto billing feature until further development
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import useBillingTemplateModalContentStyles from './styles';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { getRequiredTextMessage } from 'src/utils/formValidation';
import { ALLOCATION_METHOD, BILL_FREQUENCY_NAME, VACANT_UNIT_ALLOCATIONS_TO_PAID_BY, VACANT_UNIT_USAGE, VACANT_UNIT_USAGE_TO_TRANSLATE, vacantUnitOccupantsSummarySuffix } from 'src/constants/utilities';
import GLModal from './GLModal';
import { AddNewRateModal } from './AddNewRateModal';
import { MapColumnsModal, MapColumnsViewModal, MapColumnsEditModal, COLUMN_FIELD_MAP } from './MapColumnsModal';
import { ProvideUnitMeterIDsModal } from './ProvideUnitMeterIDsModal';
import { SubmeterDisclosures, DISCLOSURE_FIELDS } from './SubmeterDisclosures';
import { toJS } from 'mobx';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import { ProviderSetupPlain } from 'src/components/property/PropertyUtilitiesSetupPageV2/ProviderSetupModal/plain';
import { AddProviderPlain } from 'src/components/property/PropertyUtilitiesSetupPageV2/AddProviderModalV2/plain';
import { AssociatedVendor } from 'src/components/shared/AssociatedVendor';
import { ApPushSwitch } from 'src/components/ApPushSwitch';
import { BillReadyDayField } from 'src/components/BillReadyDayField';
import { UtilityCredentialSlot } from 'src/components/property/UtilityPortalCredentials/UtilityCredentialSlot';
import { EMPTY_PENDING_CREDENTIAL } from 'src/components/property/UtilityPortalCredentials/PendingCredentialFields';
import { savePendingCredential } from 'src/components/property/UtilityPortalCredentials/savePendingCredential';
import { isScraperSupported } from 'src/components/property/UtilityPortalCredentials/credentialStatus';
import { currentCompanyId } from 'src/components/property/UtilityPortalCredentials/currentCompanyId';
import { canManageUtilityCredentials } from 'src/utils/canManageUtilityCredentials';

/** Backend may send 0.55 (decimal) or 55 (percentage). Returns integer 0-100 for display. */
function formatVacantUnitUsageLimitPercent(value) {
  const n = Number(value !== null && value !== void 0 ? value : 0);
  if (Number.isNaN(n)) return 0;
  return n <= 1 && n > 0 ? Math.round(n * 100) : Math.round(n);
}
export const ModalContent = observer(_ref => {
  var _store$homeDashboardS, _store$homeDashboardS2, _utility$provider12, _utility$provider14, _utility$provider15, _utility$provider16, _utility$provider17, _store$addNewProperty2, _store$homeDashboardS37, _store$homeDashboardS38, _store$addNewProperty3, _store$addNewProperty4;
  let utility = _ref.utility,
    isEditing = _ref.isEditing,
    handleClose = _ref.handleClose;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles({
    modalHasNoMargin: true,
    modalHasNoPadding: true
  });
  const classes = useBillingTemplateModalContentStyles();
  const isSubmeterEnabled = store.account.featureFlagsStore.getEnableSubmeterBilling;
  const _useState = useState('gal'),
    _useState2 = _slicedToArray(_useState, 2),
    unitOfMeasure = _useState2[0],
    setUnitOfMeasure = _useState2[1];
  const handleUnitOfMeasureChange = event => {
    if (event.target.value) setUnitOfMeasure(event.target.value);
  };
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isProviderSetupModalOpen = _useState4[0],
    setProviderSetupModalOpen = _useState4[1];
  const _useState5 = useState(() => utility.allocationMethod === ALLOCATION_METHOD.BySubmeter ? 'SubMeter' : 'RUBS'),
    _useState6 = _slicedToArray(_useState5, 2),
    billingMethodType = _useState6[0],
    setBillingMethodType = _useState6[1];
  useEffect(() => {
    setBillingMethodType(utility.allocationMethod === ALLOCATION_METHOD.BySubmeter ? 'SubMeter' : 'RUBS');
  }, [utility.allocationMethod]);
  const handleChangeMethodType = (event, value) => {
    event.preventDefault();
    if (value) setBillingMethodType(value);
  };
  const getDefaultUtilitySettings = (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.getUtilityInfoById(isEditing ? utility.utilityId : utility === null || utility === void 0 ? void 0 : utility.utilityTypeId);
  const isDefaultBySetting = settingName => {
    switch (settingName) {
      case 'allocationMethod':
        {
          return (getDefaultUtilitySettings === null || getDefaultUtilitySettings === void 0 ? void 0 : getDefaultUtilitySettings.defaultAllocationMethod) === utility.allocationMethod;
        }
      case 'vacantUnitUsage':
        {
          return (getDefaultUtilitySettings === null || getDefaultUtilitySettings === void 0 ? void 0 : getDefaultUtilitySettings.defaultVacantUnitUsage) === utility.vacantUnitUsage;
        }
      case 'commonAreaDeduction':
        {
          return getDefaultUtilitySettings !== null && getDefaultUtilitySettings !== void 0 && getDefaultUtilitySettings.cad ? utility.commonAreaDeduction === 5 : utility.commonAreaDeduction === 0;
        }
    }
  };

  // NOTE: Might be used for initial state on accordion
  // const isAllUtilityConfigDefault = () => {
  //   return (
  //     isDefaultBySetting('allocationMethod') &&
  //     isDefaultBySetting('vacantUnitUsage') &&
  //     isDefaultBySetting('commonAreaDeduction')
  //   );
  // };

  const _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isOpen = _useState8[0],
    setIsOpen = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isLoading = _useState0[0],
    setIsLoading = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isSaving = _useState10[0],
    setIsSaving = _useState10[1];

  // Utility portal credentials, for property managers and staff: the same PmRegularOrHigher the API enforces.
  //
  // In this modal `utility.id` IS the propertyUtilityId (see the save and submeter calls below),
  // except on the add path where it is the 'NEW_UTILITY_TEMPLATE' sentinel.
  const canManageCredentials = canManageUtilityCredentials();
  const isNewUtility = utility.id === 'NEW_UTILITY_TEMPLATE';
  const propertyUtilityId = isNewUtility ? null : utility.id;
  const propertyId = (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.id;
  // companyId is the selected company in local storage - the same source store.admin reads. An
  // impersonating admin therefore writes against the company they are acting as, which is the intent.
  const companyId = currentCompanyId();
  // Both sources: the edit path has utility.provider, the add path only has the configurator.
  const isScraperSupportedProvider = isScraperSupported(utility.provider, store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator);
  const pendingCredentialRef = useRef(_objectSpread({}, EMPTY_PENDING_CREDENTIAL));
  const _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    utilityCredential = _useState12[0],
    setUtilityCredential = _useState12[1];
  // 'loading' until this modal's own lookup answers. The request is silent, so isError is the
  // only signal that "no credential" actually means "could not tell", and starting at 'ready'
  // would offer the capture form during the window before the answer arrives.
  const _useState13 = useState('loading'),
    _useState14 = _slicedToArray(_useState13, 2),
    credentialState = _useState14[0],
    setCredentialState = _useState14[1];
  const loadCredential = async () => {
    if (!canManageCredentials || !propertyUtilityId) return;
    try {
      const resp = await store.admin.getUtilityCredentialsAsync.run({
        companyId,
        propertyId,
        propertyUtilityId
      });
      // run() resolves undefined both when the request failed and when a newer call on this
      // shared model cancelled it. A cancellation never sets isError, so trusting that flag
      // would classify an unanswered lookup as ready and offer the capture form.
      if (resp === undefined) {
        setCredentialState('unavailable');
        setUtilityCredential(null);
        return;
      }
      const rows = (resp === null || resp === void 0 ? void 0 : resp.response) || resp;
      setCredentialState('ready');
      setUtilityCredential(Array.isArray(rows) ? rows[0] || null : null);
    } catch (error) {
      // Never block the utility template on the credential lookup - the template is the primary job
      // of this modal and must stay editable if the credential service is unavailable.
      setCredentialState('unavailable');
      setUtilityCredential(null);
    }
  };
  useEffect(() => {
    // companyId is in the key on purpose: an impersonating admin can switch company while
    // this modal stays mounted, and without it the previous tenant's credential stays on
    // screen and editable against the new one.
    setCredentialState('loading');
    setUtilityCredential(null);
    loadCredential();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canManageCredentials, companyId, propertyUtilityId]);
  const _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    consumptionTiers = _useState16[0],
    setConsumptionTiers = _useState16[1];
  const _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    rates = _useState18[0],
    setRates = _useState18[1];
  const _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    mappings = _useState20[0],
    setMappings = _useState20[1];
  const _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    activeCsvColumnMapId = _useState22[0],
    setActiveCsvColumnMapId = _useState22[1];
  const _useState23 = useState(0),
    _useState24 = _slicedToArray(_useState23, 2),
    meterIdsProvided = _useState24[0],
    setMeterIdsProvided = _useState24[1];
  const _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    disclosures = _useState26[0],
    setDisclosures = _useState26[1];
  const handleChangeDisclosure = (key, value) => setDisclosures(prev => _objectSpread(_objectSpread({}, prev), {}, {
    [key]: value
  }));
  useEffect(() => {
    if (!isSubmeterEnabled) return;
    if (!utility.id || utility.id === 'NEW_UTILITY_TEMPLATE') return;
    if (billingMethodType !== 'SubMeter') return;
    store.allocations.getSubmeterBillingCsvMapsAsync.run({
      propertyUtilityId: utility.id
    }).then(resp => {
      var _store$homeDashboardS3, _store$homeDashboardS4;
      if (!(resp !== null && resp !== void 0 && resp.isSuccessful) || !Array.isArray(resp.response)) return;
      const units = (_store$homeDashboardS3 = (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.selectedPropertyDetails()) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.details) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.unitSetup) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.units) !== null && _store$homeDashboardS3 !== void 0 ? _store$homeDashboardS3 : [];
      const unitIdToName = Object.fromEntries(units.filter(u => u.id && u.name).map(u => [u.id, u.name]));
      const normalized = resp.response.map(m => {
        var _m$unitMappings;
        return _objectSpread(_objectSpread({}, m), {}, {
          columnMappings: COLUMN_FIELD_MAP.reduce((acc, _ref2) => {
            let field = _ref2.field;
            return _objectSpread(_objectSpread({}, acc), {}, {
              [field]: m[field] || ''
            });
          }, {}),
          unitMappings: ((_m$unitMappings = m.unitMappings) !== null && _m$unitMappings !== void 0 ? _m$unitMappings : []).reduce((acc, _ref3) => {
            let unitId = _ref3.unitId,
              identifiers = _ref3.identifiers;
            return _objectSpread(_objectSpread({}, acc), {}, {
              [unitIdToName[unitId] || unitId]: (identifiers === null || identifiers === void 0 ? void 0 : identifiers[0]) || ''
            });
          }, {})
        });
      });
      setMappings(normalized);
    });
    store.propertyUtility.getSubmeterConfigV2Async.run({
      propertyUtilityId: utility.id
    }).then(resp => {
      var _resp$response;
      if (!(resp !== null && resp !== void 0 && resp.isSuccessful)) return;
      setActiveCsvColumnMapId(((_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.csvColumnMapId) || null);
      setDisclosures(Object.fromEntries(DISCLOSURE_FIELDS.map(_ref4 => {
        var _resp$response$key, _resp$response2;
        let key = _ref4.key;
        return [key, (_resp$response$key = (_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2[key]) !== null && _resp$response$key !== void 0 ? _resp$response$key : ''];
      })));
    });
    store.allocations.getSubmeterBillingUnitMeterMapsAsync.run({
      propertyUtilityId: utility.id
    }).then(resp => {
      if (resp !== null && resp !== void 0 && resp.isSuccessful && Array.isArray(resp.response)) {
        const uniqueUnitIds = new Set(resp.response.map(e => e.unitId).filter(Boolean));
        setMeterIdsProvided(uniqueUnitIds.size);
      }
    });
  }, [billingMethodType, utility.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAddTier = () => {
    setConsumptionTiers(prev => [...prev, {
      id: Date.now(),
      value: '',
      unit: unitOfMeasure
    }]);
  };
  const handleRemoveTier = id => setConsumptionTiers(prev => prev.filter(tier => tier.id !== id));
  const handleAddRate = rateData => setRates(prev => [...prev, _objectSpread({
    id: Date.now()
  }, rateData)]);
  const handleRemoveRate = id => setRates(prev => prev.filter(r => r.id !== id));
  const handleAddMapping = mappingData => setMappings(prev => [...prev, mappingData]);
  const handleUpdateMapping = updatedMapping => setMappings(prev => prev.map(m => m.id === updatedMapping.id ? updatedMapping : m));
  const handleSetActiveMapping = async mappingId => {
    const resp = await store.propertyUtility.updateCsvColumnMapAsync.run({
      propertyUtilityId: utility.id,
      csvColumnMapId: mappingId
    });
    if (!(resp !== null && resp !== void 0 && resp.isSuccessful)) return;
    setActiveCsvColumnMapId(mappingId);
    toast('success', {
      body: ['Mapping set as active!']
    });
  };
  const handleRemoveMapping = async id => {
    const resp = await store.allocations.deleteSubmeterBillingCsvMapAsync.run({
      id
    });
    if (!(resp !== null && resp !== void 0 && resp.isSuccessful)) return;
    toast('success', {
      body: ['Mapping deleted!']
    });
    setMappings(prev => prev.filter(m => m.id !== id));
  };
  const _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    searchResultItems = _useState28[0],
    setSearchResultItems = _useState28[1];
  let searchUtilityProvidersHandler;
  const searchUtilityProviders = async (event, value) => {
    if (value && value.trim().length > 0) {
      if (searchUtilityProvidersHandler) {
        setSearchResultItems([]);
        clearTimeout(searchUtilityProvidersHandler);
      }
      searchUtilityProvidersHandler = setTimeout(() => store.utilityProviders.searchUtilityProvidersAsync.run(value).then(resp => {
        setSearchResultItems([{
          id: 'createCustomProviderId',
          key: 'createCustomProviderKey',
          label: value + ' (add new provider)',
          inputName: value
        }, ...resp.response.map(item => {
          return _objectSpread(_objectSpread({}, item), {}, {
            id: item.key,
            key: item.key,
            label: item.value
          });
        })]);
      }), 350);
    } else {
      if (searchUtilityProvidersHandler) clearTimeout(searchUtilityProvidersHandler);
    }
    setSearchResultItems([{
      id: 'createCustomProviderId',
      key: 'createCustomProviderKey',
      label: value + ' (add new provider)',
      inputName: value
    }]);
  };
  const _useState29 = useState(utility.provider.isCustom || false),
    _useState30 = _slicedToArray(_useState29, 2),
    isCustomProviderMode = _useState30[0],
    setIsCustomProviderMode = _useState30[1];
  const _useState31 = useState(''),
    _useState32 = _slicedToArray(_useState31, 2),
    customProviderName = _useState32[0],
    setCustomProviderName = _useState32[1];
  const GetBillingSettingsList = observer(() => {
    var _store$homeDashboardS5, _store$homeDashboardS6, _store$homeDashboardS7;
    const list = [{
      title: t('add_new_property_flow.bill_frequency'),
      id: "UtilityAccordion_bill_frequency_id",
      key: "UtilityAccordion_bill_frequency_key_".concat(utility.billFrequencyType),
      value: BILL_FREQUENCY_NAME[utility.billFrequencyType],
      isActive: true,
      isDefault: true,
      action: /*#__PURE__*/React.createElement(BillFrequencyModal, {
        propertyUtility: utility,
        isEdit: isEditing
      })
    }, {
      title: t('add_new_property_flow.allocation_method'),
      id: "UtilityAccordion_allocation_method_id",
      key: "UtilityAccordion_allocation_method_key_".concat(utility.allocationMethod),
      value: isSubmeterEnabled && billingMethodType === 'SubMeter' ? CONSTANTS.ALLOCATION_METHODS.BySubmeter : CONSTANTS.ALLOCATION_METHODS[utility.allocationMethod] + "".concat((utility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || utility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && Number((_store$homeDashboardS5 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.propertyBuildingSquare) === 0 ? ' (Error: Property Sq. footage not defined!)' : ''),
      isDefault: isDefaultBySetting('allocationMethod'),
      isActive: true,
      isError: (utility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || utility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && Number((_store$homeDashboardS6 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.propertyBuildingSquare) === 0,
      action: isSubmeterEnabled && billingMethodType === 'SubMeter' ? null : /*#__PURE__*/React.createElement(AllocationMethodModal, {
        propertyUtility: utility,
        billingMethod: billingMethodType,
        isEdit: isEditing
      })
    }, {
      title: t('add_new_property_flow.handling_vacant_unit'),
      id: "UtilityAccordion_handling_vacant_unit_id",
      key: "UtilityAccordion_handling_vacant_unit_key_".concat(utility.vacantUnitUsage),
      value: "".concat(t(VACANT_UNIT_USAGE_TO_TRANSLATE[utility.vacantUnitUsage])).concat(utility.vacantUnitUsage === VACANT_UNIT_USAGE.LimitedUsage ? " (".concat(formatVacantUnitUsageLimitPercent(utility === null || utility === void 0 ? void 0 : utility.vacantUnitUsageLimit), "%)") : vacantUnitOccupantsSummarySuffix(t, utility.vacantUnitUsage, utility.vacantUnitOccupantsCount)),
      isDefault: isDefaultBySetting('vacantUnitUsage'),
      isActive: true,
      action: /*#__PURE__*/React.createElement(VacantUnitBills, {
        propertyUtility: utility,
        isEdit: isEditing
      })
    }, {
      title: t('add_new_property_flow.common_area_deduction'),
      id: "UtilityAccordion_common_area_deduction_id",
      key: "UtilityAccordion_common_area_deduction_key_".concat(utility.commonAreaDeduction),
      isDefault: isDefaultBySetting('commonAreaDeduction'),
      isActive: true,
      value: utility.commonAreaDeduction + '%',
      // isError: true, // NOTE: TBD if needed
      // customMode: customMode,
      action: /*#__PURE__*/React.createElement(CADModal, {
        propertyUtility: utility,
        isEdit: isEditing,
        goodWillDeductionValue: utility.goodWillDeduction,
        defaultCadEnabled: (_store$homeDashboardS7 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS7 === void 0 || (_store$homeDashboardS7 = _store$homeDashboardS7.getUtilityInfoById(isEditing ? utility.utilityId : utility === null || utility === void 0 ? void 0 : utility.utilityTypeId)) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.cad
      })
    }, {
      title: t('general.goodwill_deduction'),
      id: "UtilityAccordion_good_will_deduction_id",
      key: "UtilityAccordion_good_will_deduction_key",
      value: utility.goodWillDeduction,
      isDefault: utility.goodWillDeduction === 5,
      utilityCAD: utility.commonAreaDeduction,
      onChangeCallback: val => utility.setGoodWillDeduction(Number(val)),
      submitCallback: () => {
        // console.log('itemSubmitCallback');
      },
      isGWD: true,
      isActive: true,
      isEditable: !isEditing,
      showInfo: isEditing,
      infoComponent: /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "info",
        title: t('add_new_property_flow.update_gwd_info'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        state: "info",
        type: "question"
      })))
    }];
    if (isSubmeterEnabled && billingMethodType !== 'RUBS') {
      var _store$homeDashboardS8, _store$homeDashboardS9;
      const totalUnits = ((_store$homeDashboardS8 = (_store$homeDashboardS9 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS9 === void 0 || (_store$homeDashboardS9 = _store$homeDashboardS9.selectedPropertyDetails()) === null || _store$homeDashboardS9 === void 0 || (_store$homeDashboardS9 = _store$homeDashboardS9.details) === null || _store$homeDashboardS9 === void 0 || (_store$homeDashboardS9 = _store$homeDashboardS9.unitSetup) === null || _store$homeDashboardS9 === void 0 ? void 0 : _store$homeDashboardS9.units) !== null && _store$homeDashboardS8 !== void 0 ? _store$homeDashboardS8 : []).filter(u => u.id && u.name).length;
      const meterIdsValue = meterIdsProvided === 0 ? 'Not provided' : meterIdsProvided >= totalUnits ? 'All provided' : "Provided ".concat(meterIdsProvided, "/").concat(totalUnits);
      list.unshift({
        title: t('Meter IDs'),
        id: "UtilityAccordion_meter_ids_id",
        key: "UtilityAccordion_meter_ids_key_",
        value: meterIdsValue,
        warningValue: meterIdsProvided === 0,
        isActive: true,
        action: /*#__PURE__*/React.createElement(ProvideUnitMeterIDsModal, {
          utility: utility,
          propertyUtilityId: utility.id,
          hasMeterIds: meterIdsProvided > 0,
          onHasMeterIdsChange: setMeterIdsProvided
        })
      });
    }
    if (store.company.companyFeatureStore.isAppfolio) {
      var _store$homeDashboardS0, _store$homeDashboardS1, _store$homeDashboardS10;
      const defaultGl = (_store$homeDashboardS0 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS0 === void 0 || (_store$homeDashboardS0 = _store$homeDashboardS0.details) === null || _store$homeDashboardS0 === void 0 || (_store$homeDashboardS0 = _store$homeDashboardS0.glCodeSetup) === null || _store$homeDashboardS0 === void 0 ? void 0 : _store$homeDashboardS0.glAccountExternalId;
      const customGl = (_store$homeDashboardS1 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.details) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.glCodeSetup) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.utilityGlAccounts) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.find(ci => ci.propertyUtilityLivableId === (utility === null || utility === void 0 ? void 0 : utility.id))) === null || _store$homeDashboardS1 === void 0 ? void 0 : _store$homeDashboardS1.glAccountExternalId;
      list.push({
        title: t('Resident Charges GL Account (Income)'),
        id: "UtilityAccordion_gl_id",
        key: "UtilityAccordion_gl_key_".concat(utility === null || utility === void 0 ? void 0 : utility.id),
        isDefault: !customGl || defaultGl === customGl,
        isActive: true,
        value: (_store$homeDashboardS10 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS10 === void 0 || (_store$homeDashboardS10 = _store$homeDashboardS10.details) === null || _store$homeDashboardS10 === void 0 ? void 0 : _store$homeDashboardS10.glCodeSetup.getGlNameByCode(customGl ? customGl : defaultGl),
        action: /*#__PURE__*/React.createElement(GLModal, {
          propertyUtility: utility,
          savedValue: customGl ? customGl : defaultGl,
          onSaveAndClose: async glId => {
            var _store$homeDashboardS11;
            (_store$homeDashboardS11 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS11 === void 0 || (_store$homeDashboardS11 = _store$homeDashboardS11.details) === null || _store$homeDashboardS11 === void 0 || _store$homeDashboardS11.glCodeSetup.updateUtilityGlAccounts(utility === null || utility === void 0 ? void 0 : utility.id, glId);
          },
          isEdit: isEditing
        })
      });
      if (store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled) {
        var _store$homeDashboardS12, _store$homeDashboardS13, _store$homeDashboardS14;
        const defaultPayableGl = (_store$homeDashboardS12 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS12 === void 0 || (_store$homeDashboardS12 = _store$homeDashboardS12.details) === null || _store$homeDashboardS12 === void 0 || (_store$homeDashboardS12 = _store$homeDashboardS12.glCodeSetup) === null || _store$homeDashboardS12 === void 0 ? void 0 : _store$homeDashboardS12.accountsPayableGlAccountExternalId;
        const customPayableGl = (_store$homeDashboardS13 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS13 === void 0 || (_store$homeDashboardS13 = _store$homeDashboardS13.details) === null || _store$homeDashboardS13 === void 0 || (_store$homeDashboardS13 = _store$homeDashboardS13.glCodeSetup) === null || _store$homeDashboardS13 === void 0 || (_store$homeDashboardS13 = _store$homeDashboardS13.utilityGlAccounts) === null || _store$homeDashboardS13 === void 0 || (_store$homeDashboardS13 = _store$homeDashboardS13.find(ci => ci.propertyUtilityLivableId === (utility === null || utility === void 0 ? void 0 : utility.id))) === null || _store$homeDashboardS13 === void 0 ? void 0 : _store$homeDashboardS13.accountsPayableGlAccountExternalId;
        list.push({
          title: t('Accounts Payable GL Account (Expense)'),
          id: "UtilityAccordion_payable_gl_id",
          key: "UtilityAccordion_payable_gl_key_".concat(utility === null || utility === void 0 ? void 0 : utility.id),
          isDefault: !customPayableGl || defaultPayableGl === customPayableGl,
          isActive: true,
          value: (_store$homeDashboardS14 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS14 === void 0 || (_store$homeDashboardS14 = _store$homeDashboardS14.details) === null || _store$homeDashboardS14 === void 0 ? void 0 : _store$homeDashboardS14.glCodeSetup.getGlNameByCode(customPayableGl ? customPayableGl : defaultPayableGl),
          action: /*#__PURE__*/React.createElement(GLModal, {
            isPayable: true,
            propertyUtility: utility,
            savedValue: customPayableGl ? customPayableGl : defaultPayableGl,
            onSaveAndClose: async glId => {
              var _store$homeDashboardS15;
              (_store$homeDashboardS15 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS15 === void 0 || (_store$homeDashboardS15 = _store$homeDashboardS15.details) === null || _store$homeDashboardS15 === void 0 || _store$homeDashboardS15.glCodeSetup.updateUtilityAccountsPayableGlAccounts(utility === null || utility === void 0 ? void 0 : utility.id, glId);
            },
            isEdit: isEditing
          })
        });
      }
    }
    return list.map(item => /*#__PURE__*/React.createElement(ListItem, {
      key: !isEditing ? "List_ITEM_NEW_".concat(item.key) : "List_ITEM_".concat(item.key),
      item: item
    }));
  });
  const _useState33 = useState(undefined),
    _useState34 = _slicedToArray(_useState33, 2),
    newSelectedProviderData = _useState34[0],
    setNewSelectedProviderData = _useState34[1];
  const configureBillingTemplateBySelectedProvider = async (event, value) => {
    clearTimeout(searchUtilityProvidersHandler);
    setSearchResultItems([]);
    if (value && (value === null || value === void 0 ? void 0 : value.id) === 'createCustomProviderId') {
      // toggle custom provider create
      setIsCustomProviderMode(true);
      setCustomProviderName(value.inputName || '');
      if (utility.id === 'NEW_UTILITY_TEMPLATE') {
        utility.configureProviderModelForNewTemplate({
          name: value.inputName,
          isCustom: true,
          utilities: null
        });
      }
      return;
    }
    if (value && (value !== null && value !== void 0 && value.id || value !== null && value !== void 0 && value.utilityProviderId)) {
      await store.utilityProviders.getUtilityProvidersListDataAsync.run({
        utilityProviderIds: [value.id || value.utilityProviderId]
      }).then(async resp => {
        if (resp && resp.isSuccessful) {
          var _singleElementOfArray;
          store.addNewProperty.utilitiesSetupV2.setNewUtilityConfiguration(singleElementOfArray(resp.response));
          await store.utilityProviders.getUtilityInfoAsync.run({
            utilityIds: (_singleElementOfArray = singleElementOfArray(resp.response)) === null || _singleElementOfArray === void 0 ? void 0 : _singleElementOfArray.utilities.map(i => i.id)
          });
          setNewSelectedProviderData(_objectSpread({}, singleElementOfArray(resp.response)));
          // setIsCustomProviderMode(singleElementOfArray(resp.response).isCustom);
          utility.configureProviderModelForNewTemplate(singleElementOfArray(resp.response));
          setProviderSetupModalOpen(true);
          // if (utility.id === 'NEW_UTILITY_TEMPLATE') {
          //   // utility.removeUtilityType('all');
          // }
        }
      });
    }
  };
  const createUpdateCustomUtilityTemplate = async () => {
    var _utility$provider;
    const createEditCustomProvider = async _ref5 => {
      let isEditProvider = _ref5.isEditProvider,
        name = _ref5.name,
        website = _ref5.website,
        providerId = _ref5.providerId,
        genericUtilityTypesToAssign = _ref5.genericUtilityTypesToAssign;
      if (isEditProvider) {
        await store.utilityProviders.editCustomUtilityProvidersAsync.run({
          name,
          website,
          providerId,
          propertyId: store.homeDashboardStore.getCurrentProperty.id
        }, [utility.id]);
        return providerId;
      } else {
        const result = await store.utilityProviders.addCustomUtilityProvidersV2Async.run({
          name,
          website,
          propertyId: store.homeDashboardStore.getCurrentProperty.id,
          utilityTypeIds: genericUtilityTypesToAssign
        }, [utility.id]);
        const _ref6 = result || {},
          createdProviderId = _ref6.response,
          isSuccessful = _ref6.isSuccessful;
        if (isSuccessful) {
          return createdProviderId;
        }
      }
    };
    const createCustomUtilitiesAndApplyToProvider = async _ref7 => {
      let utilityName = _ref7.utilityName,
        allocationMethod = _ref7.allocationMethod,
        vacantUnitUsage = _ref7.vacantUnitUsage,
        vacantUnitAllocation = _ref7.vacantUnitAllocation,
        commonAreaDeduction = _ref7.commonAreaDeduction,
        providerIdToAttach = _ref7.providerIdToAttach;
      return store.utilityProviders.createCustomUtilityTypeAndAttachToProviderAsync.run({
        name: utilityName,
        defaultAllocationMethod: allocationMethod,
        defaultVacantUnitUsage: vacantUnitUsage,
        paidBy: VACANT_UNIT_ALLOCATIONS_TO_PAID_BY[vacantUnitAllocation],
        cad: !!commonAreaDeduction,
        utilityProviderId: providerIdToAttach
      }, [utility.id]);
    };
    let customProviderId;
    if (utility.id === 'NEW_UTILITY_TEMPLATE' && !((_utility$provider = utility.provider) !== null && _utility$provider !== void 0 && (_utility$provider = _utility$provider.utilityProviderId) !== null && _utility$provider !== void 0 && _utility$provider.length)) {
      // New utility + new custom provider: create provider and utility type
      customProviderId = await createEditCustomProvider({
        isEditProvider: false,
        name: utility.provider.utilityProviderName,
        website: utility.provider.website,
        providerId: undefined,
        genericUtilityTypesToAssign: utility.provider.utilities.map(i => i.utilityTypeId)
      });
      utility.provider.setUtilityProviderId(customProviderId);
      const createdCustomUtilitiesResp = await createCustomUtilitiesAndApplyToProvider({
        utilityName: utility.utilityType,
        allocationMethod: utility.allocationMethod,
        vacantUnitUsage: utility.vacantUnitUsage,
        vacantUnitAllocation: utility.vacantUnitAllocation,
        commonAreaDeduction: utility.commonAreaDeduction,
        providerIdToAttach: customProviderId
      });
      if (createdCustomUtilitiesResp !== null && createdCustomUtilitiesResp !== void 0 && createdCustomUtilitiesResp.isSuccessful) {
        utility.updateUtilityTypeIdForNewCustomUtility(createdCustomUtilitiesResp.response);
      }
    } else if (utility.id === 'NEW_UTILITY_TEMPLATE') {
      var _utility$provider2, _utility$provider3;
      // New utility + existing custom provider: update provider and create utility type
      await createEditCustomProvider({
        isEditProvider: true,
        name: utility.provider.utilityProviderName,
        website: utility.provider.website,
        providerId: (_utility$provider2 = utility.provider) === null || _utility$provider2 === void 0 ? void 0 : _utility$provider2.utilityProviderId
      });
      const createdCustomUtilitiesResp = await createCustomUtilitiesAndApplyToProvider({
        utilityName: utility.utilityType,
        allocationMethod: utility.allocationMethod,
        vacantUnitUsage: utility.vacantUnitUsage,
        vacantUnitAllocation: utility.vacantUnitAllocation,
        commonAreaDeduction: utility.commonAreaDeduction,
        providerIdToAttach: (_utility$provider3 = utility.provider) === null || _utility$provider3 === void 0 ? void 0 : _utility$provider3.utilityProviderId
      });
      if (createdCustomUtilitiesResp !== null && createdCustomUtilitiesResp !== void 0 && createdCustomUtilitiesResp.isSuccessful) {
        utility.updateUtilityTypeIdForNewCustomUtility(createdCustomUtilitiesResp.response);
      }
    } else {
      var _utility$provider4;
      // Existing utility + custom provider: only update provider, utility type already exists
      await createEditCustomProvider({
        isEditProvider: true,
        name: utility.provider.utilityProviderName,
        website: utility.provider.website,
        providerId: (_utility$provider4 = utility.provider) === null || _utility$provider4 === void 0 ? void 0 : _utility$provider4.utilityProviderId
      });
    }
    return {
      customProviderId
    };
  };
  const finalizeSavingAndFetchUpdates = unicIdsForReq => {
    store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchUtilityTemplates({
      forceUpdate: true,
      useUnicInProgress: false,
      customUnicInProgress: unicIdsForReq
    });
    // NOTE: Causes LB-5116
    // store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchPropertyUtilityProviders({
    //   useUnicInProgress: false,
    //   customUnicInProgress: unicIdsForReq,
    // });
  };
  const persistAssociatedVendor = async vendorAssociation => {
    if (!(vendorAssociation !== null && vendorAssociation !== void 0 && vendorAssociation.utilityProviderLivableId) || !(vendorAssociation !== null && vendorAssociation !== void 0 && vendorAssociation.vendorExternalId)) {
      return;
    }
    const resp = await store.vendors.associateVendorsAsync.run(vendorAssociation);
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      await store.vendors.getVendorsByUtilityProviderIdAsync.run({
        utilityProviderId: vendorAssociation.utilityProviderLivableId
      });
    }
  };
  const updateUtilityGlCodes = async () => {
    var _store$homeDashboardS16;
    const glCodeSetup = (_store$homeDashboardS16 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS16 === void 0 || (_store$homeDashboardS16 = _store$homeDashboardS16.details) === null || _store$homeDashboardS16 === void 0 ? void 0 : _store$homeDashboardS16.glCodeSetup;
    if (!glCodeSetup || glCodeSetup.utilityGlAccountsPatchSemanticallyEqual()) {
      return;
    }
    let patchValue = glCodeSetup.getUtilityGlAccountsValueForPatch();
    if (!patchValue.length) {
      patchValue = toJS(glCodeSetup.utilityGlAccounts);
    }
    if (!patchValue.length) {
      return;
    }
    if (!store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled) {
      patchValue = patchValue.map(_ref8 => {
        let accountsPayableGlAccountExternalId = _ref8.accountsPayableGlAccountExternalId,
          rest = _objectWithoutProperties(_ref8, _excluded);
        return rest;
      });
    }
    patchValue = glCodeSetup.normalizeUtilityGlAccountsForPatch(patchValue);
    await store.credentials.patchAppfolioPropertiesAsync.run({
      properties: [{
        propertyLivableId: store.homeDashboardStore.getCurrentProperty.id,
        utilityGlAccounts: {
          value: patchValue
        }
      }]
    });
    glCodeSetup.handleUtilityGlAccountsSave();
  };
  const createUpdateUtilityTemplate = async function () {
    var _store$homeDashboardS21, _store$homeDashboardS22;
    let _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      vendorAssociation = _ref9.vendorAssociation,
      _ref9$silent = _ref9.silent,
      silent = _ref9$silent === void 0 ? false : _ref9$silent;
    const afterUtilitySave = async () => {
      await updateUtilityGlCodes();
      await persistAssociatedVendor(vendorAssociation);
    };
    if (utility.id === 'NEW_UTILITY_TEMPLATE') {
      var _store$homeDashboardS17, _utility$provider5, _utility$provider7, _store$homeDashboardS19, _store$homeDashboardS20;
      // NOTE: Adding
      if (((_store$homeDashboardS17 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS17 === void 0 || (_store$homeDashboardS17 = _store$homeDashboardS17.selectedPropertyDetails()) === null || _store$homeDashboardS17 === void 0 || (_store$homeDashboardS17 = _store$homeDashboardS17.details) === null || _store$homeDashboardS17 === void 0 ? void 0 : _store$homeDashboardS17.getPropertyUtilityProvider((_utility$provider5 = utility.provider) === null || _utility$provider5 === void 0 ? void 0 : _utility$provider5.utilityProviderId)) === null) {
        var _store$homeDashboardS18, _utility$provider6;
        const addPropertyUtilityProviderAsyncResp = await store.properties.addPropertyUtilityProviderAsync.run({
          propertyId: (_store$homeDashboardS18 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS18 === void 0 ? void 0 : _store$homeDashboardS18.id,
          utilityProviderId: (_utility$provider6 = utility.provider) === null || _utility$provider6 === void 0 ? void 0 : _utility$provider6.utilityProviderId
        }, [utility.id]);
        if (addPropertyUtilityProviderAsyncResp !== null && addPropertyUtilityProviderAsyncResp !== void 0 && addPropertyUtilityProviderAsyncResp.isSuccessful) {
          console.log('addPropertyUtilityProviderAsyncResp', addPropertyUtilityProviderAsyncResp.response);
        }
      }
      const utilityTemplateReqObj = _objectSpread(_objectSpread({}, utility), {}, {
        id: utility.utilityId,
        utilityProviderId: (_utility$provider7 = utility.provider) === null || _utility$provider7 === void 0 ? void 0 : _utility$provider7.utilityProviderId,
        buildingIds: [(_store$homeDashboardS19 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS19 === void 0 ? void 0 : _store$homeDashboardS19.propertyBuildingId],
        vacantUnitUsageLimit: utility.vacantUnitUsageLimit / 100,
        customCommonAreaDeduction: utility.commonAreaDeduction,
        allocationMethod: isSubmeterEnabled && billingMethodType === 'SubMeter' ? ALLOCATION_METHOD.BySubmeter : utility.allocationMethod
      });
      delete utilityTemplateReqObj.provider;
      delete utilityTemplateReqObj.lastUpdateTime;
      delete utilityTemplateReqObj.utilityTypes;
      return store.propertyUtility.addNewPropertyUtilityConfigBatchAsync.run({
        propertyId: (_store$homeDashboardS20 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS20 === void 0 ? void 0 : _store$homeDashboardS20.id,
        propertyUtilities: [utilityTemplateReqObj]
      }, [utility.id]).then(async () => {
        await afterUtilitySave();
        toast('success', {
          body: ['Utility template added!']
        });
        finalizeSavingAndFetchUpdates([utility.id]);
      });
    }
    // NOTE: Editing
    const updateAsync = silent ? store.propertyUtility.updateNewPropertyUtilityConfigSilentAsync : store.propertyUtility.updateNewPropertyUtilityConfigAsync;
    return updateAsync.run(_objectSpread(_objectSpread({}, utility), {}, {
      propertyUtilityId: utility.id,
      propertyId: (_store$homeDashboardS21 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS21 === void 0 ? void 0 : _store$homeDashboardS21.id,
      buildingIds: [(_store$homeDashboardS22 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS22 === void 0 ? void 0 : _store$homeDashboardS22.propertyBuildingId],
      vacantUnitUsageLimit: utility.vacantUnitUsageLimit / 100,
      customCommonAreaDeduction: utility.commonAreaDeduction,
      allocationMethod: isSubmeterEnabled && billingMethodType === 'SubMeter' ? ALLOCATION_METHOD.BySubmeter : utility.allocationMethod
    }), [utility.id]).catch(() => {
      updateAsync.clearReqUnicIds();
    }).then(async resp => {
      if (resp === undefined) return false;
      await afterUtilitySave();
      toast('success', {
        body: ['Utility template updated!']
      });
      finalizeSavingAndFetchUpdates([utility.id]);
      return true;
    });
  };
  const buildVendorAssociationPayload = (vendorExternalIdSnapshot, utilityProviderLivableIdOverride) => {
    var _utility$provider8;
    const vendorExternalId = vendorExternalIdSnapshot !== null && vendorExternalIdSnapshot !== void 0 ? vendorExternalIdSnapshot : store.vendors.tempData.vendorExternalId;
    if (!store.company.companyFeatureStore.isAppfolio || !store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled) {
      return null;
    }
    const utilityProviderLivableId = utilityProviderLivableIdOverride !== null && utilityProviderLivableIdOverride !== void 0 ? utilityProviderLivableIdOverride : (_utility$provider8 = utility.provider) === null || _utility$provider8 === void 0 ? void 0 : _utility$provider8.utilityProviderId;
    if (!utilityProviderLivableId || !vendorExternalId) {
      return null;
    }
    return {
      utilityProviderLivableId,
      vendorExternalId
    };
  };
  const saveDisclosures = async () => {
    if (!isSubmeterEnabled || billingMethodType !== 'SubMeter' || !utility.id || utility.id === 'NEW_UTILITY_TEMPLATE' || !disclosures) {
      return null;
    }
    const resp = await store.propertyUtility.setSubmeterDisclosuresAsync.run(_objectSpread({
      propertyUtilityId: utility.id
    }, Object.fromEntries(DISCLOSURE_FIELDS.map(_ref0 => {
      let key = _ref0.key;
      return [key, disclosures[key].trim() || null];
    })))).catch(() => undefined);
    if (resp !== null && resp !== void 0 && resp.isSuccessful) return true;
    toast('error', {
      title: 'Utility not saved',
      body: ['The disclosures were not saved, so nothing was saved. Try again.']
    });
    return false;
  };
  const saveTemplate = async () => {
    if (billingMethodType === 'RUBS' && utility.allocationMethod === ALLOCATION_METHOD.BySubmeter) {
      toast('error', {
        title: 'Choose a RUBS method',
        body: ['Switching to RUBS needs an allocation method. Pick one, then save.']
      });
      return;
    }
    const disclosuresSaved = await saveDisclosures();
    if (disclosuresSaved === false) return;
    const vendorExternalIdSnapshot = store.vendors.tempData.vendorExternalId;
    // Snapshot the secret and drop it from the form immediately: everything below is async and the
    // modal starts closing in the finally block.
    const pendingCredential = pendingCredentialRef.current;
    pendingCredentialRef.current = _objectSpread({}, EMPTY_PENDING_CREDENTIAL);
    const wasNewUtility = isNewUtility;
    let keepOpen = false;
    try {
      var _utility$provider9;
      let templateSaved;
      if (isCustomProviderMode || utility !== null && utility !== void 0 && (_utility$provider9 = utility.provider) !== null && _utility$provider9 !== void 0 && _utility$provider9.isCustom) {
        var _utility$provider0;
        await createUpdateCustomUtilityTemplate();
        const providerIdForVendor = (_utility$provider0 = utility.provider) === null || _utility$provider0 === void 0 ? void 0 : _utility$provider0.utilityProviderId;
        templateSaved = await createUpdateUtilityTemplate({
          vendorAssociation: buildVendorAssociationPayload(vendorExternalIdSnapshot, providerIdForVendor),
          silent: disclosuresSaved === true
        });
      } else {
        templateSaved = await createUpdateUtilityTemplate({
          vendorAssociation: buildVendorAssociationPayload(vendorExternalIdSnapshot),
          silent: disclosuresSaved === true
        });
      }
      if (templateSaved === false) {
        keepOpen = true;
        if (disclosuresSaved) {
          toast('error', {
            title: 'Utility not saved',
            body: ['The disclosures were saved, but the utility was not. Try again.']
          });
        }
        return;
      }
      // After the utility exists, never before - the credential row must reference a real
      // propertyUtilityId. A failure here is reported but does not undo the utility.
      if (wasNewUtility && canManageCredentials) {
        var _utility$provider1;
        await savePendingCredential({
          store,
          pending: pendingCredential,
          companyId,
          propertyId,
          utilityProviderId: (_utility$provider1 = utility.provider) === null || _utility$provider1 === void 0 ? void 0 : _utility$provider1.utilityProviderId,
          utilityTypeId: utility.utilityTypeId
        });
      }
    } catch (e) {
      console.error('handleTemplateSave', e);
    } finally {
      if (!keepOpen) handleClose();
    }
  };
  const handleTemplateSave = async () => {
    setIsSaving(true);
    try {
      await saveTemplate();
    } finally {
      setIsSaving(false);
    }
  };
  const fetchSavedUtilities = async function () {
    let _ref1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref1$loadGlSettings = _ref1.loadGlSettings,
      loadGlSettings = _ref1$loadGlSettings === void 0 ? false : _ref1$loadGlSettings;
    store.addNewProperty.utilitiesSetupV2.setRentGlId('');
    store.addNewProperty.utilitiesSetupV2.setGlobalGlId('');
    store.addNewProperty.utilitiesSetupV2.setAccountsPayableGlId('');
    store.addNewProperty.utilitiesSetupV2.resetStoreToInitValues();
    if (loadGlSettings) store.credentials.resetUtilitiesGlSettings();
    const _await$Promise$all = await Promise.all([await store.properties.getPropertyAsync.run({
        propertyId: store.homeDashboardStore.getCurrentProperty.id
      }), store.properties.getPropertyUtilityProvidersV3Async.run({
        propertyId: store.homeDashboardStore.getCurrentProperty.id,
        forceSelectedUpdate: true
      }, [store.homeDashboardStore.getCurrentProperty.id]).then(async getPropertyUtilityProvidersAsyncResp => {
        var _getPropertyUtilityPr;
        if (getPropertyUtilityProvidersAsyncResp !== null && getPropertyUtilityProvidersAsyncResp !== void 0 && getPropertyUtilityProvidersAsyncResp.isSuccessful && getPropertyUtilityProvidersAsyncResp !== null && getPropertyUtilityProvidersAsyncResp !== void 0 && (_getPropertyUtilityPr = getPropertyUtilityProvidersAsyncResp.response) !== null && _getPropertyUtilityPr !== void 0 && _getPropertyUtilityPr.length) {
          const UtProvidersIds = getPropertyUtilityProvidersAsyncResp.response.map(utProvider => utProvider.utilityProviderId);
          const getUtilityProvidersListDataAsyncRes = await store.utilityProviders.getUtilityProvidersListDataAsync.run({
            utilityProviderIds: UtProvidersIds
          });
          if (getUtilityProvidersListDataAsyncRes !== null && getUtilityProvidersListDataAsyncRes !== void 0 && getUtilityProvidersListDataAsyncRes.isSuccessful) {
            var _getUtilityProvidersL;
            if (getUtilityProvidersListDataAsyncRes !== null && getUtilityProvidersListDataAsyncRes !== void 0 && (_getUtilityProvidersL = getUtilityProvidersListDataAsyncRes.response) !== null && _getUtilityProvidersL !== void 0 && _getUtilityProvidersL.length) {
              getUtilityProvidersListDataAsyncRes === null || getUtilityProvidersListDataAsyncRes === void 0 || getUtilityProvidersListDataAsyncRes.response.forEach(utilityProvider => store.addNewProperty.utilitiesSetupV2.addProvider(utilityProvider, true));
              const vendorsPromises = [];
              getPropertyUtilityProvidersAsyncResp === null || getPropertyUtilityProvidersAsyncResp === void 0 || getPropertyUtilityProvidersAsyncResp.response.map(utilityProvider => {
                const matchingProvider = getUtilityProvidersListDataAsyncRes.response.find(i => i.id === utilityProvider.utilityProviderId);
                const utilitiesToUpdate = utilityProvider.utilities.map(cUtility => {
                  const matchUtility = matchingProvider.utilities.find(i => i.id === cUtility.utilityId);
                  cUtility.isCustom = matchUtility === null || matchUtility === void 0 ? void 0 : matchUtility.isCustom;
                  cUtility.utilityTypeId = matchUtility === null || matchUtility === void 0 ? void 0 : matchUtility.utilityTypeId;
                  return cUtility;
                });
                store.addNewProperty.utilitiesSetupV2.setUtilitiesInfoAfterLoad([_objectSpread(_objectSpread({}, matchingProvider), {}, {
                  utilities: utilitiesToUpdate
                })], false);
                if (store.company.companyFeatureStore.isAppfolio && store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled) {
                  vendorsPromises.push(store.vendors.getVendorsByUtilityProviderIdAsync.run({
                    utilityProviderId: utilityProvider.utilityProviderId
                  }));
                }
              });
              if (vendorsPromises.length) {
                for (const vendorPromise of vendorsPromises) {
                  await vendorPromise;
                }
              }
            }
          }
        }
      })]),
      _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
      currentProperty = _await$Promise$all2[0];
    if (currentProperty && currentProperty.response && singleElementOfArray(currentProperty.response.buildings).buildingSquare) {
      store.addNewProperty.utilitiesSetupV2.changeSqFootage(singleElementOfArray(currentProperty.response.buildings).buildingSquare.toString());
    }
    if (store.company.companyFeatureStore.isAppfolio) {
      var _glProperties$respons, _currentGlProperty$ut;
      const glProperties = await store.credentials.getAppfolioPropertiesAsync.run({});
      const currentGlProperty = glProperties === null || glProperties === void 0 || (_glProperties$respons = glProperties.response) === null || _glProperties$respons === void 0 ? void 0 : _glProperties$respons.find(glItem => glItem.propertyLivableId === store.homeDashboardStore.getCurrentProperty.id);
      if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.rentGlAccountExternalId) {
        store.addNewProperty.utilitiesSetupV2.setRentGlId(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.rentGlAccountExternalId);
      }
      if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.glAccountExternalId) {
        store.addNewProperty.utilitiesSetupV2.setGlobalGlId(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.glAccountExternalId);
      }
      if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.accountsPayableGlAccountExternalId) {
        store.addNewProperty.utilitiesSetupV2.setAccountsPayableGlId(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.accountsPayableGlAccountExternalId);
      }
      if (loadGlSettings && currentGlProperty !== null && currentGlProperty !== void 0 && (_currentGlProperty$ut = currentGlProperty.utilityGlAccounts) !== null && _currentGlProperty$ut !== void 0 && _currentGlProperty$ut.length) {
        store.credentials.batchSetUtilitiesGlSettings(currentGlProperty.utilityGlAccounts, store.addNewProperty.utilitiesSetupV2.selectedUtilities);
      }
      await store.credentials.getGLAccountsAsync.run({
        applyToHomeDashboard: true
      });
    }
  };
  const getUtilityInfo = async ids => {
    const resp = await store.utilityProviders.getUtilityInfoAsync.run({
      utilityIds: ids
    });
    return resp;
  };
  const confirmUtilitySetup = async _ref10 => {
    let buildingsRespExt = _ref10.buildingsRespExt,
      propertySqFootage = _ref10.propertySqFootage;
    try {
      var _store$homeDashboardS23;
      const buildingsResp = buildingsRespExt !== undefined ? buildingsRespExt : await store.buildings.getBuildingAsync.run({
        propertyId: (_store$homeDashboardS23 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS23 === void 0 ? void 0 : _store$homeDashboardS23.id
      });
      const buildingIds = buildingsResp.isSuccessful && buildingsResp.response.map(item => item.id);
      const utilityProvidersPromises = [];
      for (const utilityProvider of store.addNewProperty.utilitiesSetupV2.utilityProviders) {
        var _store$homeDashboardS24;
        const providerToSave = {
          propertyId: (_store$homeDashboardS24 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS24 === void 0 ? void 0 : _store$homeDashboardS24.id,
          utilityProviderId: utilityProvider.id
        };
        if (!utilityProvider.isFetched) {
          utilityProvidersPromises.push(store.properties.addPropertyUtilityProviderAsync.run(providerToSave));
        }
      }
      await Promise.all(utilityProvidersPromises);
      const utilitiesToCreate = [];
      const utilitiesToSave = [];
      let isAllocationMethodBySquareFootageExist = false;
      for (const selectedUtility of store.addNewProperty.utilitiesSetupV2.selectedUtilities) {
        var _store$homeDashboardS25, _selectedUtility$vaca;
        if (selectedUtility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || selectedUtility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) isAllocationMethodBySquareFootageExist = true;
        const vacantUnitUsageLimit = selectedUtility.vacantUnitUsage === VACANT_UNIT_USAGE.LimitedUsage ? store.addNewProperty.vacantUnitUsageLimit.get(selectedUtility.utilityId) / 100 || 0.3 : undefined;
        const utilityToSave = {
          id: selectedUtility.id,
          propertyUtilityId: selectedUtility.id,
          propertyId: (_store$homeDashboardS25 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS25 === void 0 ? void 0 : _store$homeDashboardS25.id,
          utilityProviderId: selectedUtility.utilityProviderId,
          utilityId: selectedUtility.utilityId,
          billFrequencyType: selectedUtility.billFrequencyType,
          allocationMethod: selectedUtility.allocationMethod,
          buildingIds: buildingIds,
          utilityCap: selectedUtility.utilityCap,
          customCommonAreaDeduction: selectedUtility.utilityCAD,
          vacantUnitAllocation: selectedUtility.vacantUnitAllocation,
          vacantUnitUsage: selectedUtility.vacantUnitUsage,
          vacantUnitOccupantsCount: (_selectedUtility$vaca = selectedUtility.vacantUnitOccupantsCount) !== null && _selectedUtility$vaca !== void 0 ? _selectedUtility$vaca : null,
          vacantUnitUsageLimit,
          goodWillDeduction: selectedUtility.goodWillDeduction
        };
        if (selectedUtility.isFetched && selectedUtility.isEnabled) {
          utilitiesToSave.push(utilityToSave);
        } else if (!selectedUtility.isFetched && selectedUtility.isEnabled) {
          if (selectedUtility.isCustom) {
            await store.utilityProviders.createCustomUtilityTypeAndAttachToProviderAsync.run({
              name: selectedUtility.name,
              defaultAllocationMethod: selectedUtility.allocationMethod,
              defaultVacantUnitUsage: selectedUtility.vacantUnitUsage,
              paidBy: VACANT_UNIT_ALLOCATIONS_TO_PAID_BY[selectedUtility.vacantUnitAllocation],
              cad: selectedUtility.utilityCAD,
              utilityProviderId: selectedUtility.utilityProviderId
            }).then(async attachedUtilityResp => {
              if (attachedUtilityResp.isSuccessful) {
                var _attachedUtilityResp$, _attachedUtilityResp$2, _attachedUtilityResp$3;
                utilitiesToCreate.push(Object.assign(utilityToSave, {
                  id: (_attachedUtilityResp$ = attachedUtilityResp.response) === null || _attachedUtilityResp$ === void 0 ? void 0 : _attachedUtilityResp$.utilityId,
                  utilityId: attachedUtilityResp === null || attachedUtilityResp === void 0 || (_attachedUtilityResp$2 = attachedUtilityResp.response) === null || _attachedUtilityResp$2 === void 0 ? void 0 : _attachedUtilityResp$2.utilityId,
                  utilityTypeId: attachedUtilityResp === null || attachedUtilityResp === void 0 || (_attachedUtilityResp$3 = attachedUtilityResp.response) === null || _attachedUtilityResp$3 === void 0 ? void 0 : _attachedUtilityResp$3.utilityTypeId
                }));
              }
            });
          } else {
            utilitiesToCreate.push(utilityToSave);
          }
        }
      }
      const finalPromises = [];
      if (utilitiesToCreate && utilitiesToCreate.length) {
        var _store$homeDashboardS26;
        finalPromises.push(store.propertyUtility.addNewPropertyUtilityConfigBatchAsync.run({
          propertyId: (_store$homeDashboardS26 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS26 === void 0 ? void 0 : _store$homeDashboardS26.id,
          propertyUtilities: utilitiesToCreate
        }));
      }
      if (utilitiesToSave && utilitiesToSave.length) {
        var _store$homeDashboardS27;
        finalPromises.push(store.propertyUtility.updateNewPropertyUtilityConfigBatchAsync.run({
          propertyId: (_store$homeDashboardS27 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS27 === void 0 ? void 0 : _store$homeDashboardS27.id,
          propertyUtilities: utilitiesToSave
        }));
      }
      if (isAllocationMethodBySquareFootageExist && Number(propertySqFootage) >= 0 && Number(store.addNewProperty.utilitiesSetupV2.sqFootage) >= 0) {
        var _store$homeDashboardS28;
        const currentBuildingId = singleElementOfArray(buildingsResp.response).id;
        await store.properties.updatePropertyAsync.run({
          updateStore: true,
          propertyId: (_store$homeDashboardS28 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS28 === void 0 ? void 0 : _store$homeDashboardS28.id,
          buildings: [{
            buildingId: currentBuildingId,
            buildingSquare: Number(propertySqFootage) !== Number(store.addNewProperty.utilitiesSetupV2.sqFootage) && isValueNumber(propertySqFootage) ? Number(propertySqFootage) : Number(store.addNewProperty.utilitiesSetupV2.sqFootage)
          }]
        });
      }
      await Promise.all(finalPromises);
      await fetchSavedUtilities();
      if (store.credentials.utilitiesGlSettings.length > 0) {
        var _store$homeDashboardS29;
        const cUtilityArray = store.credentials.buildUtilityGlAccountsPatchValue({
          selectedUtilities: store.addNewProperty.utilitiesSetupV2.selectedUtilities,
          defaultGlAccountExternalId: store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId,
          includePayable: store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled
        });
        await store.credentials.patchAppfolioPropertiesAsync.run({
          properties: [{
            propertyLivableId: (_store$homeDashboardS29 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS29 === void 0 ? void 0 : _store$homeDashboardS29.id,
            utilityGlAccounts: {
              value: cUtilityArray
            }
          }]
        });
      }
      if (store.addNewProperty.utilitiesSetupV2.utilityIds.length) await getUtilityInfo(store.addNewProperty.utilitiesSetupV2.utilityIds);
      if (store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchBillingTemplates({
          forceUpdate: true
        });
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchPropertyUtilityProviders({
          forceUpdate: true
        });
      } else {
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchUtilityTemplates({
          forceUpdate: true
        });
      }
      if (store.company.companyFeatureStore.isAppfolio) {
        var _store$homeDashboardS30;
        (_store$homeDashboardS30 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS30 === void 0 || _store$homeDashboardS30.details.fetchPropertyAppfolioGlCodes({
          forceUpdate: true
        });
      }
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  };
  const saveUtilityProviderSetup = async function () {
    let _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      propertySqFootage = _ref11.propertySqFootage,
      createdUtilityProviderId = _ref11.createdUtilityProviderId,
      vendorExternalIdFromAddProvider = _ref11.vendorExternalIdSnapshot;
    try {
      var _store$homeDashboardS31, _ref12, _ref13, _utility$provider10, _store$addNewProperty, _ref14;
      const buildingsResp = await store.buildings.getBuildingAsync.run({
        propertyId: (_store$homeDashboardS31 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS31 === void 0 ? void 0 : _store$homeDashboardS31.id
      });
      if (store.company.companyFeatureStore.isAppfolio) {
        var _store$homeDashboardS32, _store$homeDashboardS33, _store$homeDashboardS34;
        const currentRentGl = {
          rentGlAccountExternalId: {
            value: store.addNewProperty.utilitiesSetupV2.rentGlAccountExternalId ? store.addNewProperty.utilitiesSetupV2.rentGlAccountExternalId : null
          }
        };
        const currentglobalGl = {
          glAccountExternalId: {
            value: store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId ? store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId : null
          }
        };
        const existingChargeOnDayOfMonth = (_store$homeDashboardS32 = (_store$homeDashboardS33 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS33 === void 0 || (_store$homeDashboardS33 = _store$homeDashboardS33.details) === null || _store$homeDashboardS33 === void 0 || (_store$homeDashboardS33 = _store$homeDashboardS33.glCodeSetup) === null || _store$homeDashboardS33 === void 0 ? void 0 : _store$homeDashboardS33.chargeOnDayOfMonth) !== null && _store$homeDashboardS32 !== void 0 ? _store$homeDashboardS32 : null;
        const chargeOnDayOfMonth = {
          value: existingChargeOnDayOfMonth
        };
        await store.credentials.patchAppfolioPropertiesAsync.run({
          properties: [_objectSpread(_objectSpread(_objectSpread({
            propertyLivableId: (_store$homeDashboardS34 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS34 === void 0 ? void 0 : _store$homeDashboardS34.id
          }, currentRentGl), currentglobalGl), {}, {
            chargeOnDayOfMonth
          })]
        });
      }
      if (store.credentials.utilitiesGlSettings.length > 0) {
        var _store$homeDashboardS35;
        const cUtilityArray = store.credentials.buildUtilityGlAccountsPatchValue({
          selectedUtilities: store.addNewProperty.utilitiesSetupV2.selectedUtilities,
          defaultGlAccountExternalId: store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId,
          includePayable: store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled
        });
        await store.credentials.patchAppfolioPropertiesAsync.run({
          properties: [{
            propertyLivableId: (_store$homeDashboardS35 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS35 === void 0 ? void 0 : _store$homeDashboardS35.id,
            utilityGlAccounts: {
              value: cUtilityArray
            }
          }]
        });
      }
      await confirmUtilitySetup({
        buildingsRespExt: buildingsResp,
        propertySqFootage
      });
      const providerIdForVendor = (_ref12 = (_ref13 = createdUtilityProviderId !== null && createdUtilityProviderId !== void 0 ? createdUtilityProviderId : utility === null || utility === void 0 || (_utility$provider10 = utility.provider) === null || _utility$provider10 === void 0 ? void 0 : _utility$provider10.utilityProviderId) !== null && _ref13 !== void 0 ? _ref13 : (_store$addNewProperty = store.addNewProperty.utilitiesSetupV2.selectedUtilities[0]) === null || _store$addNewProperty === void 0 ? void 0 : _store$addNewProperty.utilityProviderId) !== null && _ref12 !== void 0 ? _ref12 : null;
      const vendorExtForPersist = (_ref14 = vendorExternalIdFromAddProvider !== null && vendorExternalIdFromAddProvider !== void 0 ? vendorExternalIdFromAddProvider : store.vendors.tempData.vendorExternalId) !== null && _ref14 !== void 0 ? _ref14 : null;
      await persistAssociatedVendor(buildVendorAssociationPayload(vendorExtForPersist, providerIdForVendor || undefined));
    } catch (e) {
      console.log('error', e);
    }
  };
  const saveUtilityProvider = async () => {
    var _utility$provider11;
    setIsLoading(true);
    const configurator = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator;
    // Snapshot the secret and the chosen scope before any of the async work below.
    const pendingCredential = pendingCredentialRef.current;
    pendingCredentialRef.current = _objectSpread({}, EMPTY_PENDING_CREDENTIAL);
    const enabledUtilities = ((configurator === null || configurator === void 0 ? void 0 : configurator.utilities) || []).filter(item => item.isEnabled);
    // A credential scopes to exactly one property utility (the account row is unique per credential
    // and account number). With several utilities enabled at once there is no non-arbitrary choice,
    // so leave it unscoped rather than guess - savePendingCredential then declines and says so.
    // utilityId, not utilityTypeId: the configurator carries both and it is utilityId that ends up
    // on the created PropertyUtilities row. Verified against dev, where the two differ.
    const scopedUtilityTypeId = enabledUtilities.length === 1 ? enabledUtilities[0].utilityId || enabledUtilities[0].utilityTypeId : undefined;
    const providerIdForCredential = (configurator === null || configurator === void 0 ? void 0 : configurator.providerId) || ((_utility$provider11 = utility.provider) === null || _utility$provider11 === void 0 ? void 0 : _utility$provider11.utilityProviderId);
    store.addNewProperty.utilitiesSetupV2.addProvider(_objectSpread(_objectSpread({}, toJS(configurator)), {}, {
      id: toJS(configurator).providerId,
      name: toJS(configurator).providerName
    }), false);
    store.addNewProperty.utilitiesSetupV2.selectUtilities({
      utilities: toJS(configurator.utilities)
    });
    await saveUtilityProviderSetup({
      propertySqFootage: store.addNewProperty.utilitiesSetupV2.sqFootage
    });
    // After the utilities exist, never before - the credential row must reference a real
    // propertyUtilityId. A failure here is reported but does not undo the utilities.
    if (canManageCredentials) {
      await savePendingCredential({
        store,
        pending: pendingCredential,
        companyId,
        propertyId,
        utilityProviderId: providerIdForCredential,
        utilityTypeId: scopedUtilityTypeId
      });
    }
    setIsLoading(false);
    handleClose();
  };
  const getModalIsLoading = () => {
    var _store$propertyUtilit, _store$propertyUtilit2;
    return ((_store$propertyUtilit = store.propertyUtility.addNewPropertyUtilityConfigBatchAsync) === null || _store$propertyUtilit === void 0 || (_store$propertyUtilit = _store$propertyUtilit.inProgressUnicIds) === null || _store$propertyUtilit === void 0 ? void 0 : _store$propertyUtilit.includes(utility.id)) || ((_store$propertyUtilit2 = store.propertyUtility.updateNewPropertyUtilityConfigAsync) === null || _store$propertyUtilit2 === void 0 || (_store$propertyUtilit2 = _store$propertyUtilit2.inProgressUnicIds) === null || _store$propertyUtilit2 === void 0 ? void 0 : _store$propertyUtilit2.includes(utility.id)) || isSaving;
  };
  const handleNewProviderConfigChange = data => {
    store.addNewProperty.utilitiesSetupV2.updateNewUtilityConfiguration(data);
  };
  useEffect(() => {
    fetchSavedUtilities({
      loadGlSettings: true
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const showAssociatedVendorSection = store.company.companyFeatureStore.isAppfolio && store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled && (isCustomProviderMode || !!((_utility$provider12 = utility.provider) !== null && _utility$provider12 !== void 0 && _utility$provider12.utilityProviderId));
  useEffect(() => {
    var _utility$provider13;
    if (!showAssociatedVendorSection) {
      return undefined;
    }
    const providerId = (_utility$provider13 = utility.provider) === null || _utility$provider13 === void 0 ? void 0 : _utility$provider13.utilityProviderId;
    if (providerId) {
      store.vendors.getVendorsByUtilityProviderIdAsync.run({
        utilityProviderId: providerId
      });
    }
    return () => {
      store.vendors.changeTempDataVendor(null);
      store.vendors.changeTempDataProperty(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAssociatedVendorSection, (_utility$provider14 = utility.provider) === null || _utility$provider14 === void 0 ? void 0 : _utility$provider14.utilityProviderId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, !(isCustomProviderMode && !isEditing) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, !isEditing && !isCustomProviderMode ? t('add_new_property_flow.find_the_provider') : t('add_new_property_flow.provider')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, !isEditing && !isCustomProviderMode ? t('add_new_property_flow.find_a_provider_of_the_utilities_that_are_mentioned_in_your_bill') : t('add_new_property_flow.provider_description'))), !isCustomProviderMode && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    autoFocus: true,
    id: "provider-selector",
    key: "key-provider-selector",
    variant: "withIcon",
    disablePortal: true,
    loading: store.utilityProviders.searchUtilityProvidersAsync.inProgress,
    disabled: isEditing,
    clearIcon: true,
    popupIcon: null,
    value: utility.provider.utilityProviderName || (newSelectedProviderData === null || newSelectedProviderData === void 0 ? void 0 : newSelectedProviderData.name),
    options: searchResultItems,
    onInputChange: searchUtilityProviders,
    onChange: configureBillingTemplateBySelectedProvider,
    renderInput: params => /*#__PURE__*/React.createElement(InputWithIcon, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "search"
      })
    }, /*#__PURE__*/React.createElement(TextField, _extends({
      autoFocus: true
    }, params, {
      id: "provider-selector",
      label: t('add_new_property_flow.provider_search')
    })))
  })), isCustomProviderMode && isEditing && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "name",
    name: "name",
    label: t('add_new_property_flow.provider_name'),
    variant: "outlined",
    fullWidth: true,
    value: utility.provider.utilityProviderName,
    onChange: e => {
      utility.provider.setUtilityProviderName(e.target.value);
    },
    error: !utility.provider.utilityProviderName && !utility.provider.utilityProviderName.length,
    helperText: !utility.provider.utilityProviderName && !utility.provider.utilityProviderName.length && getRequiredTextMessage('Provide Name')
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('add_new_property_flow.provider_website'),
    id: "website",
    name: "website",
    variant: "outlined",
    fullWidth: true,
    value: utility.provider.website,
    onChange: e => {
      utility.provider.setWebsite(e.target.value);
    }
  })))), showAssociatedVendorSection && /*#__PURE__*/React.createElement("div", {
    className: "vendors"
  }, !(isCustomProviderMode && !isEditing) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.link_associated_vendor_in_appfolio')), /*#__PURE__*/React.createElement(AssociatedVendor, {
    isModal: true,
    utilityProviderId: utility.provider.utilityProviderId,
    utilityProviderName: utility.provider.utilityProviderName
  })), isCustomProviderMode && !isEditing && /*#__PURE__*/React.createElement(AddProviderPlain, {
    provider: null,
    isEditMode: false,
    propertyId: store.homeDashboardStore.getCurrentProperty.id,
    hideNotEnabledExternal: false,
    onSave: saveUtilityProviderSetup,
    customName: customProviderName,
    handleClose: handleClose,
    isNewUtility: true
  }), (!!newSelectedProviderData || isCustomProviderMode && isEditing || utility.id !== 'NEW_UTILITY_TEMPLATE' || utility.id === 'NEW_UTILITY_TEMPLATE' && ((_utility$provider15 = utility.provider) === null || _utility$provider15 === void 0 || (_utility$provider15 = _utility$provider15.utilities) === null || _utility$provider15 === void 0 ? void 0 : _utility$provider15.length)) && !isProviderSetupModalOpen && /*#__PURE__*/React.createElement(UtilitiesAutocomplete, {
    key: 'SelectedUtilitiesAutocompleteKey',
    id: 'SelectedUtilitiesAutocompleteId',
    utility: utility,
    currentProviderDataExt: newSelectedProviderData,
    isCustomProviderMode: isCustomProviderMode
  }), /*#__PURE__*/React.createElement(BillReadyDayField, {
    propertyUtilityId: propertyUtilityId,
    className: classes.xlSection
  }), /*#__PURE__*/React.createElement(ApPushSwitch, {
    propertyUtilityId: propertyUtilityId,
    className: classes.xlSection
  }), /*#__PURE__*/React.createElement(UtilityCredentialSlot, {
    canManageCredentials: canManageCredentials,
    isAutomated: isScraperSupportedProvider,
    className: classes.xlSection,
    companyId: companyId,
    propertyId: propertyId,
    propertyUtilityId: propertyUtilityId,
    utilityProviderId: (_utility$provider16 = utility.provider) === null || _utility$provider16 === void 0 ? void 0 : _utility$provider16.utilityProviderId,
    utilityTypeId: utility.utilityId,
    providerName: (_utility$provider17 = utility.provider) === null || _utility$provider17 === void 0 ? void 0 : _utility$provider17.utilityProviderName,
    credential: utilityCredential,
    credentialState: credentialState,
    onChanged: loadCredential,
    pendingRef: pendingCredentialRef
  }), isProviderSetupModalOpen && !isEditing && !isCustomProviderMode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ProviderSetupPlain, {
    externalIsOpen: true,
    handleConfigChange: handleNewProviderConfigChange,
    propertyId: store.homeDashboardStore.getCurrentProperty.id,
    utilityProviderId: (_store$addNewProperty2 = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator) === null || _store$addNewProperty2 === void 0 ? void 0 : _store$addNewProperty2.providerId,
    isDetailsPage: true,
    isNewUtility: true
  })), (utility === null || utility === void 0 ? void 0 : utility.utilityType) !== null && !isProviderSetupModalOpen && /*#__PURE__*/React.createElement(React.Fragment, null, isSubmeterEnabled && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 4
    }
  }, "Select billing method"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, "Select whether to use RUBS or the sub-meter billing method."), /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    exclusive: true,
    size: "small",
    value: billingMethodType,
    onChange: handleChangeMethodType
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "RUBS"
  }, "RUBS"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "SubMeter"
  }, "Sub-meter"))), false && billingMethodType !== 'RUBS' && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 4
    }
  }, "Select unit of measure"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, "Select all of the utilities that are represented in your real bill."), /*#__PURE__*/React.createElement(Select, {
    size: "small",
    label: "Unit of measure",
    value: unitOfMeasure,
    onChange: handleUnitOfMeasureChange,
    style: {
      minWidth: 200
    },
    notched: false,
    displayEmpty: true,
    renderValue: val => val ? "".concat(val === 'gal' ? 'Gallons' : val, " (").concat(val, ")") : 'Unit of measure'
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "gal"
  }, "Gallons (gal)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "hcf"
  }, "HCF (hcf)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "kgal"
  }, "Kgal (kgal)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "ccf"
  }, "CCF (ccf)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "kWh"
  }, "kWh (kWh)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "BTU"
  }, "BTU (BTU)"))), false && billingMethodType !== 'RUBS' && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 4
    }
  }, "Define consumption tiers"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, "If the charges varies based on the utility amount consumed define the thresholds."), consumptionTiers.map((tier, index) => /*#__PURE__*/React.createElement("div", {
    key: tier.id,
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      marginBottom: 8,
      padding: '8px 12px',
      border: '1px solid #e0e0e0',
      borderRadius: 4
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      minWidth: 104,
      fontWeight: 600
    }
  }, "Tier ", index + 1, " treshold"), /*#__PURE__*/React.createElement(TextField, {
    size: "small",
    style: {
      width: 120
    },
    value: tier.value,
    onChange: e => setConsumptionTiers(prev => prev.map(ct => ct.id === tier.id ? _objectSpread(_objectSpread({}, ct), {}, {
      value: e.target.value
    }) : ct)),
    InputProps: unitOfMeasure ? {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, unitOfMeasure)
    } : undefined
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    size: "small",
    onClick: () => handleRemoveTier(tier.id),
    style: {
      minWidth: 0,
      padding: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  })))), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    size: "small",
    onClick: handleAddTier
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Add tier"))), false && billingMethodType === 'SubMeter' && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 12
    }
  }, "Define the rates"), rates.map(rate => /*#__PURE__*/React.createElement("div", {
    key: rate.id,
    style: {
      padding: '12px 16px',
      border: '1px solid #e0e0e0',
      borderRadius: 4,
      marginBottom: 8,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600
    }
  }, rate.rateName), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, "".concat(rate.rateType === 'charge' ? 'Charge' : 'Credit', " - ").concat(rate.rateIn).concat(rate.rateValue, " \xD7 ").concat(rate.ratePerUnit || '-'))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 4,
      flexShrink: 0,
      marginLeft: 8
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: () => handleRemoveRate(rate.id)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  })), /*#__PURE__*/React.createElement(IconButton, {
    size: "small"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }))))), /*#__PURE__*/React.createElement(AddNewRateModal, {
    onSave: handleAddRate
  })), isSubmeterEnabled && billingMethodType === 'SubMeter' && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 12
    }
  }, "Map columns"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, "Map your CSV meter read columns to our system's field names."), mappings.map(mapping => {
    var _store$homeDashboardS36;
    const isActive = activeCsvColumnMapId === mapping.id;
    return /*#__PURE__*/React.createElement("div", {
      key: mapping.id,
      className: isActive ? classes.activeMappingRow : classes.mappingRow
    }, /*#__PURE__*/React.createElement(MapColumnsViewModal, {
      mapping: mapping
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.mappingRowRight
    }, isActive ? /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.activeBadge
    }, "Active") : /*#__PURE__*/React.createElement(Button, {
      variant: "actionButtonInvert",
      size: "small",
      onClick: () => handleSetActiveMapping(mapping.id),
      disabled: store.propertyUtility.updateCsvColumnMapAsync.inProgress
    }, "Set active"), /*#__PURE__*/React.createElement(MapColumnsEditModal, {
      mapping: mapping,
      propertyId: (_store$homeDashboardS36 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS36 === void 0 ? void 0 : _store$homeDashboardS36.id,
      utilityId: utility.utilityId,
      propertyUtilityId: utility.id,
      onSave: handleUpdateMapping
    }), isActive ? /*#__PURE__*/React.createElement(ExpandedTooltip, {
      title: "To delete this mapping, set another mapping as active first",
      placement: "top"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
      disabled: true
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "delete"
    })))) : /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => handleRemoveMapping(mapping.id)
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "delete"
    }))));
  }), /*#__PURE__*/React.createElement(MapColumnsModal, {
    propertyId: (_store$homeDashboardS37 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS37 === void 0 ? void 0 : _store$homeDashboardS37.id,
    utilityId: utility.utilityId,
    propertyUtilityId: utility.id,
    onSave: handleAddMapping
  })), isSubmeterEnabled && billingMethodType === 'SubMeter' && disclosures && /*#__PURE__*/React.createElement(SubmeterDisclosures, {
    className: classes.xlSection,
    values: disclosures,
    onChange: handleChangeDisclosure
  })), (utility === null || utility === void 0 ? void 0 : utility.utilityType) !== null && !isProviderSetupModalOpen && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.billing_settings')), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isOpen
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    id: "utility-content",
    "aria-controls": "utility-content",
    onClick: () => setIsOpen(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContentTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.default_settings'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.accordionContentIcon, " ").concat(isOpen ? 'open' : '')
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    type: "arrow-line-down"
  })))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBody
  }, /*#__PURE__*/React.createElement(GetBillingSettingsList, null))))))), !(isCustomProviderMode && !isEditing) && /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    disabled: getModalIsLoading(),
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      handleClose();
    },
    'custom-attribute': '617-new-billing-module'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    disabled: !isProviderSetupModalOpen && (getModalIsLoading() || (utility === null || utility === void 0 ? void 0 : utility.utilityId) === null || (utility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || utility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && Number((_store$homeDashboardS38 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS38 === void 0 ? void 0 : _store$homeDashboardS38.propertyBuildingSquare) === 0 || isCustomProviderMode && !utility.provider.utilityProviderName && !utility.provider.utilityProviderName.length) || isProviderSetupModalOpen && (((_store$addNewProperty3 = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator) === null || _store$addNewProperty3 === void 0 ? void 0 : _store$addNewProperty3.utilities.filter(i => i.isEnabled).length) === 0 || ((_store$addNewProperty4 = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator) === null || _store$addNewProperty4 === void 0 ? void 0 : _store$addNewProperty4.utilities.filter(i => i.isEnabled && (ALLOCATION_METHOD.BySquareFootage === i.allocationMethod || ALLOCATION_METHOD.By50Occupancy50SquareFootage === i.allocationMethod)).length) !== 0 && Number(store.addNewProperty.utilitiesSetupV2.sqFootage) === 0),
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      if (isProviderSetupModalOpen) {
        saveUtilityProvider();
      } else {
        void handleTemplateSave();
      }
    },
    'custom-attribute': '618-new-billing-module'
  }, t('Save utility')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading || getModalIsLoading()
  }));
});